import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <img src="/assets/images/arrowright.svg" alt="" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <img src="/assets/images/arrowleft.svg" alt="" />
    </div>
  );
}

function SampleNextArrow2(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <img
        src="/assets/images/arrowright.svg"
        onClick={props.onChangeUpperImage}
        alt=""
      />
    </div>
  );
}

function SamplePrevArrow2(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <img
        src="/assets/images/arrowleft.svg"
        onClick={props.onChangeUpperImage}
        alt=""
      />
    </div>
  );
}

const SliderPopup = ({ galleryData, onCancel, initialIndex, folderName, showSlider}) => {
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const [currentImageIndex, setCurrentImageIndex] = useState(initialIndex);

  useEffect(() => {
    setCurrentImageIndex(initialIndex);
  }, [initialIndex]);

  const upperimage = {
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: nav2,
    arrows: true,
    infinite: false,
    dots: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          // initialSlide: currentImageIndex, // Set initial slide here
          arrows: false,
        },
      },
    ],
    // initialSlide: currentImageIndex,
  };

  const thumbimage = {
    slidesToShow: 8,
    swipeToSlide: 2,
    focusOnSelect: true,
    infinite: false,
    dots: false,
    arrows: true,
    nextArrow: (
      <SampleNextArrow2
        onChangeUpperImage={() => setSlide1(currentImageIndex + 1)}
      />
    ),
    prevArrow: (
      <SamplePrevArrow2
        onChangeUpperImage={() => setSlide1(currentImageIndex - 1)}
      />
    ),
    // initialSlide: currentImageIndex, // Set initial slide here
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          // initialSlide: currentImageIndex, // Set initial slide here
          arrows: true,
        },
      },
    ],
  };

  const handleClose = () => {
    onCancel();
  };

  const handleDownload = async () => {
    try {
      const imageUrl = galleryData[currentImageIndex].file_path;

      if (window.location.href.indexOf("appversion") != -1) {
        let image = "https://appvideos.narendramodi.in/v2/" + imageUrl;
        // let encodedurl = encodeURIComponent(
        //   `https://appvideos.narendramodi.in/v2/${imageUrl}?ignore.zip`
        // );
        // let downlaodUrl = `download://?url=${encodedurl}`;
        // window.location.href = downlaodUrl;

        let encodedurl = encodeURIComponent(`${image}?q=ignore.zip`);
        let downlaodUrl = `download://?url=${encodedurl}`;
        window.location.href = downlaodUrl;
      } else {
        const downloadUrl = `https://appvideos.narendramodi.in/v2/${imageUrl}`;
        const response = await fetch(downloadUrl);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `image_${currentImageIndex}.jpg`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading image:", error);
    }
  };

  const slider1Ref = useRef(null);
  // Function to set the current slide for the main image slider
  function setSlide1(index) {
    if (slider1Ref.current) {
      slider1Ref.current.slickGoTo(index);
    }
  }

  useEffect(() => {
    // Initially set the current slide to the 5th image (index 4)
    setSlide1(currentImageIndex);
  }, [currentImageIndex]);

  return (
    <>
      <div className="sliderpopup_bg">
        <button className="cross_btnpopup" onClick={handleClose}>
          <img src="/assets/images/crosswhite.svg" alt="" />
        </button>
        <button className="download_mob" onClick={handleDownload}>
          <img src="/assets/images/download.svg" alt="" />
          
        </button>
        <div className="slider_popuppo">
          <button className="download_btn download_btn_desk" onClick={handleDownload}>
            <img src="/assets/images/download.svg" alt="" />
            Download
          </button>
          <div className="upperslider">
            <Slider
              {...upperimage}
              asNavFor={nav2}
              // ref={(slider1) => setNav1(slider1)}
              ref={slider1Ref}
              beforeChange={(oldIndex, newIndex) =>
                setCurrentImageIndex(newIndex)
              }
            >
              {galleryData.map((item, index) => (
                <div key={index} className="upper_img">
                  <div className="upper_banner">
                    <img
                      src={`https://new-dam-java.b-cdn.net/${item.file_path}`}
                      className="upperbanner"
                      alt={item.file_name}
                      style={{ marginLeft: "0" }}
                    />
                    <h5 style={{ marginLeft: "0" }}>{folderName}</h5>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className="slider_thum_div">
            <Slider
              {...thumbimage}
              asNavFor={nav1}
              ref={(slider2) => setNav2(slider2)}
            >
              {galleryData.map((item, index) => (
                <div key={index}>
                  <div className="slidethumb">
                    <img
                      onClick={() => setSlide1(index)}
                      src={`https://new-dam-java.b-cdn.net/${item.file_path}`}
                      className=""
                      alt=""
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default SliderPopup;
